import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'Sort'
})
export class Sort implements PipeTransform {
    transform(values: any[]) {
        if (!values || !values === undefined) {
            return values;
        }

        return values.sort((a, b) => b.id - a.id);
    }
}
